import { render, staticRenderFns } from "./ProjectHeaderInfoClientSubcontractorInfo.vue?vue&type=template&id=61b409d8&scoped=true&"
import script from "./ProjectHeaderInfoClientSubcontractorInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectHeaderInfoClientSubcontractorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHeaderInfoClientSubcontractorInfo.vue?vue&type=style&index=0&id=61b409d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b409d8",
  null
  
)

export default component.exports